import React from "react";
import Logo from "./Logo";
import { studioInfo } from "../../mock";

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer className="border-t border-white/10 bg-[#0a0a0a]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col md:flex-row justify-between gap-12">
          <div>
            <Logo className="h-20" />
            <p className="font-mono-label text-[10px] text-white/45 mt-5">
              Premium Training Studio · Torino
            </p>
          </div>

          <div className="flex flex-wrap gap-14">
            <div>
              <div className="font-mono-label text-[10px] text-white/40 mb-4">Menu</div>
              <div className="flex flex-col gap-3">
                {["studio", "servizi", "recensioni", "contatti"].map((id) => (
                  <button
                    key={id}
                    onClick={() => scrollTo(id)}
                    className="text-white/70 hover:text-white transition-colors duration-300 capitalize text-left"
                  >
                    {id}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <div className="font-mono-label text-[10px] text-white/40 mb-4">Contatti</div>
              <div className="flex flex-col gap-3">
                <a href={`tel:${studioInfo.phoneHref}`} className="text-white/70 hover:text-white transition-colors duration-300">
                  {studioInfo.phone}
                </a>
                <span className="text-white/70">{studioInfo.address}</span>
                <span className="text-white/70">{studioInfo.city}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Dati legali società */}
        <div className="mt-14 pt-8 border-t border-white/10">
          <div className="font-mono-label text-[10px] text-white/40 mb-4">Dati aziendali</div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-y-3 gap-x-8 text-white/55 text-sm">
            <div>
              <span className="text-white/35 block text-xs mb-0.5">Ragione sociale</span>
              ONEVO Premium Training Studio S.r.l.s.
            </div>
            <div>
              <span className="text-white/35 block text-xs mb-0.5">Partita IVA / C.F.</span>
              13430580012
            </div>
            <div>
              <span className="text-white/35 block text-xs mb-0.5">REA</span>
              TO - 1362538
            </div>
            <div>
              <span className="text-white/35 block text-xs mb-0.5">Sede legale</span>
              Via Pastrengo 15, 10128 Torino (TO)
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-4 mt-12 pt-8 border-t border-white/10">
          <span className="font-mono-label text-[10px] text-white/35">
            © {new Date().getFullYear()} ONEVO Premium Training Studio S.r.l.s. · P.IVA 13430580012 · Tutti i diritti riservati
          </span>
          <div className="flex items-center gap-6">
            <a href="/privacy" className="font-mono-label text-[10px] text-white/35 hover:text-white/70 transition-colors duration-300">
              Privacy & Cookie
            </a>
            <a href="/admin" className="font-mono-label text-[10px] text-white/35 hover:text-white/70 transition-colors duration-300">
              Area riservata
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
